import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'libero-instrument-filter-search',
  templateUrl: './instrument-filter-search.component.html',
  styleUrls: ['./instrument-filter-search.component.scss'],
  standalone: false
})
export class InstrumentFilterSearchComponent {
  @Input() public formName!: AbstractControl;
  @Input() public placeholder!: string;

  private _currentInputValue?: string | undefined;

  public get currentInputValue(): string | undefined {
    return this.formName.value;
  }

  public set currentInputValue(value: string | undefined) {
    this._currentInputValue = value;
  }

  public updateValue(): void {
    this.formName.patchValue(this._currentInputValue);
    this.formName.markAsTouched();
    this.formName.markAsDirty();
  }
}
